import {parseNumber, isInteger} from "../../lib/utils";

export default {
  data() {
    return {
      participantsCountStepNumber: 1,
      racesPerParticipantsStepNumber: 2,
      ageConfirmationStepNumber: 3,
      dateSelectionStepNumber: 4,
      personalDetailsStepNumber: 5,
      pricingSummaryStepNumber: 6,
    }
  },
  computed: {
    disabled() {
      return this.termsAgreed !== 'yes'
    },
    participantsNotSet() {
      const count = parseNumber(this.totalPlayers)
      return this.disabled || !isInteger(count, 1) ||
        count > this.racersLimit
    },
    racerNotSet() {
      return this.disabled || this.participantsNotSet || this.isGroupEventDetected
    },
    isRaceTypeSet() {
      return !this.racerNotSet && this.raceType
    },
    isAgeTermsAgreed() {
      return !this.racerNotSet && this.ageTermsAgreed === 'yes'
    },
    dateNotSelected() {
      return !this.isRaceTypeSet || !this.selectedDate
    },
    showTimeslotInputs() {
      return !this.dateNotSelected
    },
    showTimeslotInfo() {
      return this.showTimeslotInputs && !_.isEmpty(this.retrievedTimeslots)
    },
    disabledPersonalDetails() {
      return !this.isAgeTermsAgreed
    },
    showMiniCart() {
      return this.showTimeslotInputs && !!parseNumber(this.numberOfRaces)
    },
    notAllRacersSlotted() {
      return this.totalRacesSlotted < parseNumber(this.numberOfAdultRaces)
    },
    cartNotReady() {
      return this.isPersonalDetailsInvalid ||
        !this.showMiniCart ||
        this.isAnyProcessing() ||
        this.notAllRacersSlotted
    },
  }
}
